import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
  root: {
    fontSize: '0.75rem'
  }
});

const CreatePpsiButton = ({ route }) => {
  const classes = useStyles();
  const history = useHistory();

  function handleClick() {
    history.push(route);
  }

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={handleClick}
      classes={{ root: classes.root }}
    >
      <FormattedMessage id="ppsi.createInstruction" />
    </Button>
  );
};

CreatePpsiButton.propTypes = {
  route: PropTypes.string.isRequired
};

export default CreatePpsiButton;
